import $ from 'jquery';
import rangeslider from 'rangeslider.js/dist/rangeslider';

import 'css/animations.scss';

export default class Animation {
  constructor(options = {}) {
    this._slided = false;
    this._sources = options.sources;
    this._steps = options.steps;
    this._canvasWidth = options.canvasWidth;
    this._canvasHeight = options.canvasHeight;
    this._element = options.element;

    this._sprites = this._sources.map((source) => {
      let sprite = new Image();
      sprite.src = source;

      return sprite
    });

    this._canvas = this._element.querySelector('canvas');
    this._canvas.width = this._canvasWidth;
    this._canvas.height = this._canvasHeight;

    $(this._element).find('input[type=range]').rangeslider({
      polyfill: false,
      onSlide: (_, value) => {
        this.render(value)
      }
    })
  }

  render(numberOfFrame) {
    let context = this._canvas.getContext("2d");

    if (!this._slided && numberOfFrame > 0) {
      window.ga('send', {
        hitType: 'event',
        eventCategory: 'Interaction',
        eventAction: 'slide',
        eventLabel: 'slide'
      })
      this._slided = true;
    }

    // Clear the canvas
    context.clearRect(0, 0, this._canvasWidth, this._canvasHeight);

    context.drawImage(
      this._sprites[numberOfFrame],
      0,
      0,
      this._canvasWidth,
      this._canvasHeight
    );

    this._element.querySelector('.card-text').innerHTML = this._steps[numberOfFrame];
  }
}
